import { ContainerLogBookResponseModel } from "@gtpl/shared-models/logistics";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { ContainerLogBookIdRequestDto } from "./dto/container-log-book-id.request.dto";
import { LogBookItemsService } from "./log-book-items.service";

@ApiTags('Log Book Items')
@Controller('log-book-items')
export class LogBookItemsController {
    constructor(private service: LogBookItemsService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/getLogBookItemDetails')
    async getLogBookItemDetails(@Body() req:ContainerLogBookIdRequestDto): Promise <CommonResponse> {
        try {
            return await this.service.getLogBookItemDetails(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

}